import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import UserDetail from "../components/UserDetail";
import useFetchUserDetail from "../hooks/useFetchUserDetail";
import { ErrorSnackbar } from "../components/Snackbar/ErrorSnackbar";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const UserDetailsPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: userDetail, loading, error, refetch } = useFetchUserDetail(id);

  const [errorOpen, setErrorOpen] = useState(false);

  useEffect(() => {
    if (error) {
      setErrorOpen(true);
    }
  }, [error]);

  if (loading) {
    return (
      <div className="p-6 flex justify-center items-center h-screen">
        <CircularProgress />
      </div>
    );
  }

  if (!userDetail && !error) {
    return (
      <Box p={6}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => navigate("/usuarios")} sx={{ textTransform: "none" }}>
            Volver a usuarios
          </Button>
        </Box>
        <p className="text-gray-500 italic">No se encontraron asignaciones para este usuario.</p>
      </Box>
    );
  }

  return (
    <>
      {userDetail && <UserDetail user={userDetail} refetchUserDetail={refetch} />}
      {error && (
        <>
          <ErrorSnackbar open={errorOpen} onClose={() => setErrorOpen(false)} title="Ha ocurrido un error" message={error.message} />
          <p className="p-6 text-gray-500 italic">Ha ocurrido un error, por favor inténtalo más tarde.</p>
        </>
      )}
    </>
  );
};

export default UserDetailsPage;
